import { VERSION as t } from "./_setup.js";
function o(t) {
  return t instanceof o ? t : this instanceof o ? void (this._wrapped = t) : new o(t);
}
o.VERSION = t, o.prototype.value = function () {
  return this._wrapped;
}, o.prototype.valueOf = o.prototype.toJSON = o.prototype.value, o.prototype.toString = function () {
  return String(this._wrapped);
};
export { o as default };